import { render, staticRenderFns } from "./ModuleBiList.vue?vue&type=template&id=2e7db420"
import script from "./ModuleBiList.vue?vue&type=script&lang=js"
export * from "./ModuleBiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports